import VSelectVoucherStatus from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectVoucherStatus', VSelectVoucherStatus),
};
